<template>
    <div class="gh-section way-to-learn">
        <div class="container">
            <h2 class="gh-section__heading">Learning at Mental Health Academy</h2>
            <div class="row">
                <div v-for="(feature, index) in features" :key="index" class="col-xs-12 col-sm-6 col-md-3 blurb">
                    <div class="gh-blurb">
                        <div class="gh-blurb__header">
                            <div class="gh-blurb__icon">
                                <img :src="iconPath(feature)" :alt="feature.title" loading="lazy">
                            </div>
                            <p class="gh-blurb__heading">{{ feature.title }}</p>
                        </div>

                        <div class="gh-blurb__body">
                            <p>{{ feature.description }}</p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="action">
                <router-link class="gh-button gh-button--primary" to="/about-us#learning-modes">LEARN MORE</router-link>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            features() {
                return [
                    {
                        iconName: 'learning-icons-tc.svg',
                        title: 'Text Courses',
                        description: 'Access over 120 specialist text-based courses, written specifically for CPD in mental health.'
                    },
                    {
                        iconName: 'learning-icons-vc.svg',
                        title: 'Video Courses',
                        description: 'Watch 250+ hours of video content facilitated by global mental health experts.'
                    },
                    {
                        iconName: 'learning-icons-c.svg',
                        title: 'Collections',
                        description: 'Advance your specialised knowledge with our hand-picked topic collections.'
                    },
                    {
                        iconName: 'learning-icons-e.svg',
                        title: 'Events',
                        description: 'Interact with leading topic specialists in real-time with our online Summits and webinars.'
                    }
                ];
            }
        },

        methods: {
            iconPath(feature) {
                return `images/app/${feature.iconName}`;
            }
        }
    }
</script>
